export default function paymentRedirect(orderId: string, token: string) {
  const redirectUrl = `${
    process.env.REACT_APP_REDIRECT_URL || ''
  }/platform?orderId=${orderId}&token=${encodeURIComponent(token)}`;
  window.location.href = redirectUrl;
}
